$(function() {
  'use strict';
  
  const initTextareaCharCounter = () => {
    $('.js-report-form-char-counter').each((_, textarea) => {
      const { dataset: { showCounter, counterId } } = textarea;
      
      // カウンター表示が無効な場合はスキップ
      if (showCounter !== 'true') return;
      
      const counter = document.getElementById(counterId);
      
      // カウンター要素が見つからない場合はスキップ
      if (!counter) return;
      
      // input: リアルタイム入力時、paste: ペースト時
      // setTimeoutでペースト後のDOM更新を待つ
      $(textarea).on('input paste', () => {
        setTimeout(() => {
          counter.textContent = textarea.value.length;
        }, 0);
      }).trigger('input'); // 初期値設定のためトリガー
    });
  };
  
  initTextareaCharCounter();
});
